import { ApolloError } from "@apollo/client";
import {
  FilterFindManyTagGroupInput,
  FilterFindOneTagGroupInput,
  TagGroup,
} from "gql/generated";
import { createContext } from "react";

export type TagGroupContextValues = {
  tagGroups: TagGroup[];
  loading: boolean;
  error: ApolloError | undefined;
  getTagGroup: (filter: FilterFindOneTagGroupInput) => TagGroup | undefined;
  getTagGroups: (filter: FilterFindManyTagGroupInput) => TagGroup[];
  getTagGroupsByIds: (ids: string[]) => TagGroup[];
  //   getTagGroupsByIds: (ids: string[]) => TagGroup[];
  //   getTagGroupsByKeys: (
  //     keys: EnumTagGroupKey[],
  //     types?: EnumTagGroupType[],
  //   ) => TagGroup[];
  //   getTagGroupsByTypes: (types: EnumTagGroupType[]) => TagGroup[];
};

export const TagGroupContext = createContext<TagGroupContextValues | null>(
  null,
);
